import "./FormSwitch.scss";
import { deepEqual } from "@/core/util/helpers";

export default {
  model: {
    prop: "inputValue",
    event: "change"
  },

  props: {
    value: null,
    inputValue: null,
    disabled: Boolean,
    readonly: Boolean,
    label: String
  },

  data() {
    return {
      lazyValue: this.inputValue
    };
  },

  watch: {
    value(val) {
      this.lazyValue = val;
    },
    inputValue(val) {
      this.lazyValue = val;
    }
  },

  computed: {
    internalValue: {
      get() {
        return this.lazyValue;
      },
      set(val) {
        this.lazyValue = val;
        this.$emit("change", val);
      }
    },

    isActive() {
      const value = this.value;
      const input = this.internalValue;

      return value ? deepEqual(value, input) : Boolean(input);
    },

    isDisabled() {
      return this.disabled || this.readonly;
    },

    hasLabel() {
      return !!(this.$slots.label || this.label);
    },

    classes() {
      return {
        switch_active: this.isActive,
        switch_disabled: this.isDisabled
      };
    }
  },
  methods: {
    genDefaultSlot() {
      return [this.genSwitch(), this.genLabel()];
    },

    genSwitch() {
      return this.$createElement(
        "label",
        {
          staticClass: "switch",
          class: this.classes
        },
        [
          this.genInput("checkbox", {
            ...this.$attrs
          }),

          this.$createElement("div", { staticClass: "switch__track" }, [
            this.$createElement("div", { staticClass: "switch__thumb" })
          ])
        ]
      );
    },

    genLabel() {
      if (!this.hasLabel) return null;
      return this.$createElement(
        "span",
        {
          staticClass: "label",
          class: {},
          attrs: {},
          style: {},
          on: { click: this.onChange },
          ref: "label"
        },
        this.$slots.label || this.label
      );
    },

    genInput(type, attrs) {
      return this.$createElement("input", {
        attrs: Object.assign(
          {
            "aria-label": this.label,
            "aria-checked": this.isActive.toString(),
            disabled: this.isDisabled,
            role: "checkbox",
            type: "checkbox"
          },
          attrs
        ),
        domProps: {
          value: this.value,
          checked: this.isActive
        },
        on: {
          blur: this.onBlur,
          change: this.onChange,
          focus: this.onFocus,
          keydown: this.onKeydown
        },
        ref: "input"
      });
    },

    onBlur() {
      this.isFocused = false;
    },
    onChange() {
      if (this.isDisabled) return;

      const value = this.value;
      let input = this.internalValue;

      if (value) {
        input = deepEqual(input, value) ? null : value;
      } else {
        input = !input;
      }
      this.internalValue = input;
    },
    onFocus() {
      this.isFocused = true;
    },
    onKeydown() {}
  },

  render(h) {
    return h(
      "div",
      {
        staticClass: "form-switch"
      },
      this.genDefaultSlot()
    );
  }
};
